import PropTypes from 'prop-types'
import React from 'react'

const Form = (props) => {
  return (
    <form
      onSubmit={(e) => e.preventDefault()}
      aria-label='form'
    >
      {props.children}
    </form>
  )
}

export default Form

Form.propTypes = {
  children: PropTypes.node.isRequired
}
